import React, { FC, Fragment } from 'react';

import { formatDate } from 'formatters';
import { cn } from 'utils';

import styles from './DateTimeline.module.scss';

export type TimelinePoint = {
  date?: Date | null;
  label: string;
  reached?: boolean;
};

type Props = {
  points?: Array<TimelinePoint>;
  startDate?: Date | null;
  endDate?: Date | null;
  startLabel?: string;
  endLabel?: string;
  startReached?: boolean;
  endReached?: boolean;
  className?: string;
};

const alignOf = (index: number, total: number): string => {
  if (index === 0) return styles.alignStart;
  if (index === total - 1) return styles.alignEnd;
  return styles.alignCenter;
};

const DateTimeline: FC<Props> = ({
  points,
  startDate,
  endDate,
  startLabel = 'Старт проекта',
  endLabel = 'Конец проекта',
  startReached = true,
  endReached = false,
  className,
}) => {
  const resolvedPoints: Array<TimelinePoint> = points ?? [
    { date: startDate, label: startLabel, reached: startReached },
    { date: endDate, label: endLabel, reached: endReached },
  ];

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.dates}>
        {resolvedPoints.map((point, index) => (
          <span
            key={point.label}
            className={cn(styles.date, alignOf(index, resolvedPoints.length))}
          >
            {point.date ? formatDate(point.date) : '—'}
          </span>
        ))}
      </div>
      <div className={styles.line}>
        {resolvedPoints.map((point, index) => (
          <Fragment key={point.label}>
            {index > 0 && <span className={styles.connector} />}
            <span className={cn(styles.node, point.reached && styles.nodeReached)} />
          </Fragment>
        ))}
      </div>
      <div className={styles.labels}>
        {resolvedPoints.map((point, index) => (
          <span
            key={point.label}
            className={cn(styles.label, alignOf(index, resolvedPoints.length))}
          >
            {point.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default DateTimeline;
